import TaskCard from "../components/TaskCard";
import TaskForm from "../components/TaskForm";
import { useContext } from "react";
import { TaskContext } from "../context/ContextTask";
import Spinner from "../components/Spinner";

export default function Home() {
  const { tasks, loading } = useContext(TaskContext);
  return (
    <div className="container-lg mybody">
      <div className="row">
        <div className="col-12 col-md-5 col-lg-4 mb-2">
          <TaskForm />
        </div>
        <div className="col-12 col-md-7 col-lg-8">
          <div className="row">
            {loading ? (
              <Spinner />
            ) : tasks.length > 0 ? (
              tasks.map((task) => <TaskCard key={task._id} task={task} />)
            ) : (
              <div className="row"> No hay tareas</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
